import { useCallback, useState } from "react";

type BooleanState = boolean;
type SetFalse = () => void;
type SetTrue = () => void;

/**
 * Hook wrapping the required state and callback hooks for handling boolean states.
 *
 * @param initialBooleanState of the dialog
 * @return `[BooleanState (= boolean), SetFalse = (boolean) => void, SetTrue = (boolean) => void]`
 */
export const useBooleanState = (initialBooleanState: BooleanState | (() => BooleanState) = false): [BooleanState, SetFalse, SetTrue] => {
    const [boolean, setValue] = useState(initialBooleanState);
    const setFalse = useCallback(() => setValue(false), [setValue]);
    const setTrue = useCallback(() => setValue(true), [setValue]);
    return [boolean, setFalse, setTrue];
};
